var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
const BRANCH_BASE_URL = 'https://branch.wallet.bitcoin.com/';
const getOSLink = ({ android = '', iOS = '', fallback = '' }) => {
    if (typeof window === 'undefined') {
        return fallback;
    }
    const userAgent = window.navigator.userAgent || window.opera;
    if (/android/i.test(userAgent)) {
        return android || fallback;
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return iOS || fallback;
    }
    return fallback;
};
export const useBranchFallback = ({ branch = '', android = '', iOS = '', fallback = '', }) => {
    const [link, setLink] = useState(branch);
    const [tested, setTested] = useState(false);
    useEffect(() => {
        const testBranch = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const branchResponse = yield fetch(BRANCH_BASE_URL, {
                    redirect: 'manual',
                });
                if (branchResponse.type !== 'opaqueredirect' && !branchResponse.ok) {
                    const osLink = getOSLink({ android, iOS, fallback });
                    setLink(osLink);
                }
            }
            catch (e) {
                const osLink = getOSLink({ android, iOS, fallback });
                setLink(osLink);
            }
            setTested(true);
        });
        if (branch.startsWith(BRANCH_BASE_URL) && !tested) {
            testBranch();
        }
    }, [branch, android, iOS, fallback, tested]);
    return link;
};
//# sourceMappingURL=useBranchFallback.js.map